import { ShippingRuleClassEnum } from '@/constants/enum';
import { IRule } from '@/types/newSetup.type';

interface IProps {
  rule?: IRule;
}

function ShippingPrivacyMore({ rule }: IProps) {
  const { ShippingPrivacyMorePopup, ShippingPrivacyMore } = ShippingRuleClassEnum;
  if (!rule?.privacyMore) return <></>;
  const privacyMoreText = rule.privacyMore?.replace('\n', '<br>');
  return (
    <span className={ShippingPrivacyMore}>
      <span className={ShippingPrivacyMorePopup}>{privacyMoreText || ''}</span>
    </span>
  );
}

export default ShippingPrivacyMore;
